/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component } from 'react';
import { withStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles'

import { Avatar, Tooltip, Typography, Button, Breadcrumbs, Link, IconButton } from '@material-ui/core'
import { ArrowDropDown, ArrowRight, DeviceHub, Input, FlashOn, Add } from '@material-ui/icons'
import { TreeView, TreeItem } from '@material-ui/lab'

import DataMarker from '../../../CreateIC/AddDataDevice/DataMarker/DataMarker'
import { v4 as uuidv4 } from 'uuid';
const clone = require("rfdc")();
let equal = require('deep-equal')

const blue_theme = createMuiTheme({
    palette: {
      primary: {
        main: "#2296f3",
      },
      secondary: {
        main: "#dc004e",
      },
    },
});

const styles = theme => ({
    tree_root: {
        color: theme.palette.text.secondary,
        '&:hover > $content': {
          backgroundColor: theme.palette.action.hover,
        },
        '&:focus > $content, &$selected > $content': {
          backgroundColor: `var(--tree-view-bg-color, rgba(0,0,0,0.5)})`,
          color: 'var(--tree-view-color)',
        },
        '&:focus > $content $label, &:hover > $content $label, &$selected > $content $label': {
          backgroundColor: 'transparent',
        },
    },
    avatar_small: {
        width: theme.spacing(4),
        height: theme.spacing(4),
    }
})

class Filter extends Component {
    state = {
        expanded : [],
        selected : null,
        temp_filters : [],
        applied_filters : [],
        filters : this.props.filter_config
    }

    componentWillMount () {
        console.log("Filter :: Selected IC Objects : ", this.props.ic_list)
        console.log("Filter :: Selected IC Filters : ", this.props.filter_config)
        if (this.props.ic_list.length !== 0) {
            //if (this.props.filter_config.length === 0) {
                let filters = this.props.filter_config
                this.props.ic_list.map(ic => {
                    if(filters.find(filter => ic.name === filter.ic_name)!== -1) {
                        let ic_filter = {
                            ic_name : ic.name,
                            op_filters : []
                        }
                        ic.operations.map(operation => {
                            let op_filter = {
                                op_name : operation,
                                data_markers : [],
                                iu_filters : []
                            }
                            ic.information_units.map(iu => {
                                let iu_filter = {
                                    iu_name : iu.name,
                                    data_markers : []
                                }
                                op_filter.iu_filters.push(iu_filter)
                            })
                            ic_filter.op_filters.push(op_filter)
                        })
                        filters.push(ic_filter)
                    }    
                })
    
                this.setState({...this.state, filters : filters}, () => console.log("Setting Initial Filter : ", this.state))
            //}
        }
    }

    componentDidMount () {
        console.log("Filter Props :", this.props.ic_list)
    }

    renderTreeIC = (ic_object) => {
        const { classes } = this.props
        console.log("Rendering Tree IC : ", ic_object)
        return (
            <TreeItem 
                nodeId = {ic_object.name} 
                label = {
                    <div style = {{
                        display : 'flex',
                        alignItems: 'center',
                        padding : '5px'
                    }}>
                        <Tooltip title = "Information Channel">
                            <DeviceHub fontSize = 'small' style = {{color : "#0bb5b0"}}/>
                        </Tooltip>
                        <Typography style = {{marginLeft : '5px'}} variant = 'subtitle2' >{ic_object.name}</Typography>
                    </div>
                }
            >
                {ic_object.operationAnnotations.filter(operation => operation.is_filterable === true).map(op => this.renderTreeOperation(ic_object, op.type))}
            </TreeItem>
        )
    }

    renderTreeOperation = (ic_object, operation) => {
        const { classes } = this.props
        return (
            <TreeItem 
                nodeId = {ic_object.name + "/" + operation}
                label = {
                    <div style = {{
                        display : 'flex',
                        alignItems: 'center',
                        padding : '5px'
                    }}>
                        <Tooltip title = {"Operation"}>
                            <FlashOn fontSize = 'small' style = {{color : "#FF6701"}}/>
                        </Tooltip>
                        <Typography style = {{marginLeft : '5px'}} variant = 'subtitle2' >{ic_object.operationAnnotations.find(op => op.type === operation).annotation}</Typography>
                    </div>
                }>
                {ic_object.information_units.map(iu => this.renderTreeIU(ic_object, operation, iu.name))}
            </TreeItem>
        )
    }

    renderTreeIU = (ic_object, operation, iu_name) => {
        return (
            <TreeItem 
                nodeId = {ic_object.name + "/" + operation + "/" + iu_name} 
                label = {
                    <div style = {{
                        display : 'flex',
                        alignItems: 'center',
                        padding : '5px'
                    }}>
                        <Tooltip title = "Information Unit">
                            <Input fontSize = 'small' style = {{color : "#2296f3"}}/>
                        </Tooltip>
                        <Typography style = {{marginLeft : '5px'}} variant = 'subtitle2' >{iu_name}</Typography>
                    </div>
                }
            ></TreeItem>
        )
    }

    renderTree = () => {
        console.log("Rendering Tree : ", this.props.ic_list)
                // let filters = []
                // this.props.ic_list.map(ic => {
                //     let ic_filter = {
                //         ic_name : ic.name,
                //         op_filters : []
                //     }
                //     ic.operations.map(operation => {
                //         let op_filter = {
                //             op_name : operation,
                //             data_markers : [],
                //             iu_filters : []
                //         }
                //         ic.information_units.map(iu => {
                //             let iu_filter = {
                //                 iu_name : iu.name,
                //                 data_markers : []
                //             }
                //             op_filter.iu_filters.push(iu_filter)
                //         })
                //         ic_filter.op_filters.push(op_filter)
                //     })
                //     filters.push(ic_filter)
                // })
    
                // this.setState({...this.state, filters : filters}, () => console.log("Setting Initial Filter : ", this.state))

        let ics = this.props.ic_list.map(ic => this.renderTreeIC(ic))
        
        return ics
    }

    handleToggle = (event, nodeIds) => {
        console.log("Tree View Toggling : ", nodeIds)
        this.setState({expanded : nodeIds}, () => console.log("Tree View Toggled : ", this.state))
    }

    handleSelect = (event, nodeIds) => {
        this.setState({selected : nodeIds}, () => console.log("Tree View Selected : ", this.state))
    }

    renderTreeView = () => {
        const { classes } = this.props
        return(
            <div>
                <TreeView
                    className = {classes.tree_root}
                    defaultCollapseIcon={<ArrowDropDown />}
                    defaultExpandIcon={<ArrowRight />}
                    defaultEndIcon={<div style={{ width: 24 }} />}
                    expanded={this.state.expanded}
                    selected={this.state.selected}
                    onNodeToggle={this.handleToggle}
                    onNodeSelect={this.handleSelect}
                >
                    {this.renderTree()}
                </TreeView>
            </div>
        )
    }

    renderCrumb = (crumb_name, index) => {
        if (index === 0) {
            return (
                <div style = {{display : 'flex'}}>
                    <Tooltip title = "Information Channel">
                        <DeviceHub 
                            fontSize = 'small' 
                            style = {{color : "#0bb5b0"}}
                        />
                    </Tooltip>
                    <Typography style = {{marginLeft : '5px'}} variant = 'caption' color = "textSecondary">{crumb_name}</Typography>
                </div>
            )
        }

        if (index === 1) {
            return (
                <div style = {{display : 'flex'}}>
                    <Tooltip title = "Operation">
                        <FlashOn 
                            fontSize = 'small' 
                            style = {{color : "#FF6701"}}
                        />
                    </Tooltip>
                    <Typography style = {{marginLeft : '5px'}} variant = 'caption' color = "textSecondary">{crumb_name}</Typography>
                </div>
            )
        }

        if (index === 2) {
            return (
                <div style = {{display : 'flex'}}>
                    <Tooltip title = "Information Unit">
                        <Input 
                            fontSize = 'small' 
                            style = {{color : "#2296f3"}}
                        />
                    </Tooltip>
                    <Typography style = {{marginLeft : '5px'}} variant = 'caption' color = "textSecondary">{crumb_name}</Typography>
                </div>
            )
        }
    }

    renderBreadCrumb = () => {
        if (this.state.selected !== null) {
            let breadcrumbs = this.state.selected.split("/").map((crumb, i) => {
                return this.renderCrumb(crumb, i)
            })
    
            return breadcrumbs
        }
    }

    getDataMarkers = (selected_node_id) => {
        let node_path = selected_node_id.split("/")
        let filter_object = this.state.filters.find(filter => filter.ic_name === node_path[0])
        if (node_path.length > 1) {
            let operation_filter = filter_object.op_filters.find(op_filter => op_filter.op_name === node_path[1])
            if (node_path.length > 2) {
                let iu_filter = operation_filter.iu_filters.find(iu_filter => iu_filter.iu_name === node_path[2])
                return iu_filter.data_markers
            } else {
                return operation_filter.data_markers
            }
        } else {
            return null
        }
    }

    addDataMarker = () => {
        let new_id = uuidv4()
        let new_data_marker = {
            id: new_id,
            edit: true,
            trigger: {},
            actions: [],
        }

        let node_path = this.state.selected.split("/")
        let new_filters = clone(this.state.filters)
        let filter_object = new_filters.find(filter => filter.ic_name === node_path[0])
        if (node_path.length > 1) {
            let operation_filter = filter_object.op_filters.find(op_filter => op_filter.op_name === node_path[1])
            if (node_path.length > 2) {
                let iu_filter = operation_filter.iu_filters.find(iu_filter => iu_filter.iu_name === node_path[2])
                iu_filter.data_markers.push(new_data_marker)
            } else {
                operation_filter.data_markers.push(new_data_marker)
            }
        }
        this.setState({...this.state, filters : new_filters})
    };

    pushDataMarker = (id, data_marker) => {
        let node_path = this.state.selected.split("/")
        let new_filters = clone(this.state.filters)
        let filter_object = new_filters.find(filter => filter.ic_name === node_path[0])
        if (node_path.length > 1) {
            let operation_filter = filter_object.op_filters.find(op_filter => op_filter.op_name === node_path[1])
            if (node_path.length > 2) {
                let iu_filter = operation_filter.iu_filters.find(iu_filter => iu_filter.iu_name === node_path[2])
                let index = iu_filter.data_markers.findIndex(dm => dm.id === id)
                iu_filter.data_markers[index] = data_marker
                iu_filter.data_markers[index].edit = false
            } else {
                let index = operation_filter.data_markers.findIndex(dm => dm.id === id)
                operation_filter.data_markers[index] = data_marker
                operation_filter.data_markers[index].edit = false
            }
        }
        this.setState({...this.state, filters : new_filters}, () => {
            console.log("Filter Data Marker Push : ", this.state.filters)
            this.props.save_filters(this.state.filters)
        })
    }
    
    removeDataMarker = (type, id) => {
        let node_path = this.state.selected.split("/")
        let new_filters = clone(this.state.filters)
        let filter_object = new_filters.find(filter => filter.ic_name === node_path[0])
        if (node_path.length > 1) {
            let operation_filter = filter_object.op_filters.find(op_filter => op_filter.op_name === node_path[1])
            if (node_path.length > 2) {
                let iu_filter = operation_filter.iu_filters.find(iu_filter => iu_filter.iu_name === node_path[2])
                let index = iu_filter.data_markers.findIndex(dm => dm.id === id)
                iu_filter.data_markers.splice(index, 1)
            } else {
                let index = operation_filter.data_markers.findIndex(dm => dm.id === id)
                operation_filter.data_markers.splice(index, 1)
            }
        }
        this.setState({...this.state, filters : new_filters}, () => this.props.save_filters(this.state.filters))
    }

    editDataMarker = (type, id) => {
        console.log("Editing Data Marker ID: ", id)
        console.log("Editing Data Marker Type: ", type)
        let node_path = this.state.selected.split("/")
        let new_filters = clone(this.state.filters)
        let filter_object = new_filters.find(filter => filter.ic_name === node_path[0])
        if (node_path.length > 1) {
            let operation_filter = filter_object.op_filters.find(op_filter => op_filter.op_name === node_path[1])
            if (node_path.length > 2) {
                let iu_filter = operation_filter.iu_filters.find(iu_filter => iu_filter.iu_name === node_path[2])
                let index = iu_filter.data_markers.findIndex(dm => dm.id === id)
                iu_filter.data_markers[index].edit = true
            } else {
                let index = operation_filter.data_markers.findIndex(dm => dm.id === id)
                operation_filter.data_markers[index].edit = true
            }
        }
        this.setState({...this.state, filters : new_filters}, () => this.props.save_filters(this.state.filters))
    }

    getFieldsURL = () => {
        let node_path = this.state.selected.split("/")
        if (node_path.length === 3) {
            return {
                url : '/sainapse/information_channel/' + node_path[0] + '/information_unit/' + node_path[2] + '/fields_schema',
                method : "get",
                data : {},
                params : {}
            }
        } else if (node_path.length === 2) {
            return {
                url : "/sainapse/operation/filterable_fields",
                method : "post",
                data : {},
                params : {
                    operation_name : node_path[1]
                }
            }
        }
    }

    getOperatorURL = () => {
        return {
            url : '/sainapse/filter/datamarker_operator',
            method : "get",
            data : {},
            params : {}
        }
    }

    renderDataMarkers = () => {
        let selected_data_markers = this.getDataMarkers(this.state.selected)
        console.log("Filter Data Markers : ", selected_data_markers, this.state.selected)
        let data_markers = null
        if (selected_data_markers !== null) {
            data_markers = selected_data_markers.map((dm,i) => {
                return (
                    <DataMarker
                        key={dm.id}
                        index={i}
                        data_marker={dm}
                        type = {this.state.selected}
                        field_config = {this.getFieldsURL()}
                        operator_config = {this.getOperatorURL()}
                        operator_params_config = {{
                            url : '/sainapse/filter/datamarker_operator/params',
                            method : "get",
                            data : {},
                            params : {}
                        }}
                        action_config = {{
                            url : '/sainapse/filter/datamarker_action',
                            method : "get",
                            data : {},
                            params : {}
                        }}
                        action_params_config = {{
                            url : '/sainapse/filter/datamarker_action/params',
                            method : "get",
                            data : {},
                            params : {}
                        }}
                        pushDataMarker={(id, data_marker) =>
                            this.pushDataMarker(id, data_marker)
                        }
                        removeDataMarker={(type, id) =>
                            this.removeDataMarker(type, id)
                        }
                        editDataMarker={(type, id) =>
                            this.editDataMarker(type, id)
                        }
                    />
                )
            })
        }
        return data_markers
    }

    renderButtons = (tabValue) => {
        return (
          <div style={{ display: "flex", flexDirection: "row" }}>
            <ThemeProvider theme={blue_theme}>
              <Tooltip title="Add Data Marker">
                <IconButton
                  size="small"
                  color="primary"
                  onClick={() => this.addDataMarker(tabValue)}
                >
                  <Add />
                </IconButton>
              </Tooltip>
            </ThemeProvider>
          </div>
        );
    };

    render() { 
        return (
            <div>
                <div style = {{width : '100%', height : '30px', display : 'flex', flexDirection : 'row', alignItems : 'center', padding : '10px', borderBottom: '1px solid rgba(0,0,0,0.12)'}}>
                    <Typography style = {{flexGrow: 1}} variant = 'subtitle2' color = "textPrimary">Filters</Typography>
                    {/* <Button
                        size = 'small'
                        color = "primary"
                        disabled = {equal(this.props.filter_config, this.state.filters)}
                        onClick = {() => this.props.save_filters(this.state.filters)}
                    >Save</Button> */}
                    {/* <Button
                        style = {{marginLeft : '10px'}}
                        size = 'small'
                        disabled = {equal(this.props.filter_config, this.state.filters)}
                        color = "secondary"
                        onClick = {() => this.setState({...this.state, filters : this.props.filter_config})}
                    >Cancel</Button> */}
                </div>
                <div style = {{
                    width : '100%',
                    height : '50vh',
                    display : 'flex',
                    flexDirection : 'row'
                }}>
                    <div 
                        style = {{
                            width : '20%', 
                            height : '100%', 
                            overflow: 'scroll', 
                            borderRight : '1px solid rgba(0,0,0,0.12)', 
                            padding : '10px',
                            display : 'flex',
                            flexDirection : 'column'
                        }}
                    >
                        {this.renderTreeView()}
                    </div>
                    <div
                        style = {{width : '80%', height : '100%', overflow: 'scroll', padding : '10px'}}
                    >
                        <div style = {{borderBottom : this.state.selected !== null ? '1px solid rgba(0,0,0,0.12)' : null}}>
                            <Breadcrumbs>
                                {this.renderBreadCrumb()}
                            </Breadcrumbs>
                        </div>
                        <div>
                            {this.state.selected !== null && this.renderDataMarkers()}
                            {this.state.selected !== null && this.state.selected.split("/").length > 1 && this.renderButtons()}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
 
export default withStyles(styles)(Filter);